import { AfterViewInit, Component } from '@angular/core';
import { AuthService } from 'src/app/auth/services/auth.service';

@Component({
  selector: 'opt-logout',
  templateUrl: './logout.component.html',
})
export class LogoutComponent implements AfterViewInit {
  constructor(private authService: AuthService) {}

  ngAfterViewInit(): void {
    this.authService.logout().subscribe();
  }
}
